<template>
  <div class="sky-page-function-view">
    <div class="page-from-item wsp-display-flex">
      <div class="page-from-label from-label">场景选择：</div>
      <div class="page-from-value from-value">
        <el-radio-group v-model="selectSceneId" size="mini" @change="handleSceneSelectionChange">
          <el-radio-button v-for="(scene, index) in scenes" :key="index" :label="scene.sceneId">{{
            scene.sceneName
          }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="page-from-item">
      <div class="page-from-label">服务器选择:</div>
      <div class="page-from-value">
        <el-button icon="el-icon-refresh" class="toolbar-left" @click="refushTable"></el-button>
        <div class="page-function-toolbar">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handelPrev"
            @next-click="handelNext"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="total,sizes,prev,sp,next"
            :current-page="page"
            :page-size="pageSize"
            :total="pageTotal"
          >
          </el-pagination>
        </div>
        <el-table
          ref="table"
          :border="true"
          :data="listData"
          :max-height="600"
          :show-header="true"
          :column-drag-sortable="false"
          class="sky-host-dist"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="radio" :selectable="selectable"> </el-table-column>
          <el-table-column label="服务器型号" prop="serverName" show-overflow-tooltip />
          <el-table-column label="类型" prop="typeDesc" show-overflow-tooltip width="140" />
          <el-table-column label="cpu信息" prop="cpu" show-overflow-tooltip />
          <el-table-column label="内存" prop="memory" show-overflow-tooltip />
          <el-table-column label="磁盘" prop="diskInfo" show-overflow-tooltip />
          <el-table-column label="网卡" prop="nicsInfo" show-overflow-tooltip />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination, RadioGroup, RadioButton } from 'element-ui'

import { getServerList } from '@/api/server'

// import lang from '@/lang'
export default {
  name: 'SkySoftwareTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    scenes: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data: function() {
    return {
      selectItem: null,
      dialogVisible: false,
      shwoFunViewDetail: {},
      listData: [],
      selectScene: {},
      selectable: null,
      selectSceneId: null,
      selectFuntion: [],
      pageTotal: 0,
      pageSize: 20,
      page: 1
    }
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.scenes.length == 1) {
      this.selectScene = this.scenes[0]
      this.selectSceneId = this.selectScene.sceneId
    }
  },
  methods: {
    refushTable() {
      this.getData()
    },
    getData() {
      var req_data = {
        exactMatchArr: [],
        matchArr: [],
        page: this.page - 1,
        limit: this.pageSize
      }
      getServerList(req_data).then(res => {
        this.listData = res.data.content.itemArr
        this.pageTotal = res.data.content.total
      })
    },
    handleSceneSelectionChange(val) {
      this.selectSceneId = val
      if (this.selectItem) {
        this.$emit('addSelect', { select: this.selectItem, sceneId: this.selectSceneId, type: 'Server' })
      }
    },
    handleSelectionChange(val) {
      this.selectItem = val[0]

      if (this.selectSceneId) {
        this.$emit('addSelect', { select: val[0], sceneId: this.selectSceneId, type: 'Server' })
      } else {
        this.$store.dispatch('OpenNotification', { message: '请选择你所选的服务的使用场景', type: 'error' })
      }
    },
    handleCloseDrawer() {
      this.shwoFunViewDetail = {}
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-function-view) {
  height: 100%;
  .page-from-item {
    padding: 0 6px;
    line-height: 28px;
    .page-from-item-label {
      font-size: 14px;
      font-weight: 600;
    }
    .page-from-label {
      width: 8%;
    }
    .from-value {
      padding-left: 12px;
    }
    .page-from-item-value {
    }
  }
  .page-function-toolbar {
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
